import { useTranslation } from 'react-i18next';
import { FunctionComponent, useEffect, useState } from "react";

import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { Layout, Tabs, TabsProps } from "antd";
import PageHeader from "../../../../components/page-header/PageHeader";
import { useLocation, useParams } from "react-router-dom";
import { message } from "antd/lib";
import { Button, Col, Row, Space } from "antd";
import "./detail.scss";
import { useAppStore, useCourseStructure } from "../../../../stores/stores";
import { get } from "lodash";
import { DetailContent } from "./component/detail-content/DetailContent";
import {
  getListMoocCourseDescriptionDocumentById,
  getListMoocCourseStructureById,
  getListMoocCourseStructureChapterById,
  getMoocCourseConstructionPlanById,
} from "../../../../service/course-plan-managment/mooc-course-construction-plan/moocCourseConstructionPlanApi";
import {
  TypeCourseStructure,
  TypeChapterList,
  TypeSubjectList,
  TypeCourseDescriptionDocument,
  DataTypeMoocCourseConstructionPlan,
} from "../../../../types/course-plan-managment/mooc-course-construction-plan";
import CourseStructure from "./component/course-structure/CourseStructure";
import PreviewCourseStructure from "./component/preview-course-structure/PreviewCourseStructure";
import DetailInfo from "./component/detail-info/DetailInfo";
import DescriptionDocument from "./component/description-document/DescriptionDocument";
import IsLoading from "./component/is-loading/IsLoading";
import PreviewDescriptionDocument from "./component/preview-description-document/PreviewDescriptionDocument";
import { routesConfig } from "../../../../config/routes";
import ApproveCouresConstruction from "../list-course-plan/components/approve-coures-constuction/approveCouresConstruction";
import DetailConfirm from "../../mooc-approval-plan/components/detail-confirm/DetailConfirm";

const { Content } = Layout;
const imgPath = "/images/";

const DetailCoursePlan: FunctionComponent = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const location = useLocation();
  const { state } = location;
  const mode = state && state.mode ? state.mode : null;

  const [detailData, setDetailData] = useState<any>({}); //DetailTypeMoocCourseConstructionPlan
  const [ltsIndustry, setLtsIndustry] = useState<any[]>([]); //DetailTypeMoocCourseConstructionPlan
  const [ltsIndustryGroup, setLtsIndustryGroup] = useState<any[]>([]); //DetailTypeMoocCourseConstructionPlan

  const { accountInfo, setAccountDetail } = useAppStore((state) => {
    return {
      accountInfo: state?.accountInfo,
      setAccountDetail: state?.setAccountDetail,
    };
  });

  const [isLoading, setIsLoading] = useState(false);

  const [dataListCourseStructure, setDataListCourseStructure] = useState<
    TypeChapterList[]
  >([]);

  // console.log(dataListCourseStructure);

  const [dataDescriptionDocument, setDataDescriptionDocument] = useState<
    TypeCourseDescriptionDocument[]
  >([]);

  const getDetailMoocCourseConstructionPlanData = async (id: any) => {
    try {
      await getMoocCourseConstructionPlanById(id)
        .then((res) => {
          const data = res.data.data;
          setDetailData(data);
          const allIndustries = data.moocConstructionPlanIndustry.flatMap(
            (e: any) => e.moocIndustry
          );
          setLtsIndustry(allIndustries);
          const allIndustryGroups =
            data.moocConstructionPlanIndustryGroup.flatMap(
              (e: any) => e.moocIndustryGroup
            );
          setLtsIndustryGroup(allIndustryGroups);
        })
        .catch((err) => {
          console.log(err);
          message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
        });
    } catch (error) {
      console.log(error);
      message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
    }
  };

  const getListMoocCourseStructureByIdData = async (id: any) => {
    try {
      await getListMoocCourseStructureById(id)
        .then((res) => {
          const data = res.data.data;
          setDataListCourseStructure(changeToChapterList(data));
        })
        .catch((err) => {
          console.log(err);
          message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
        });
    } catch (error) {
      console.log(error);
      message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
    }
  };

  const getListMoocCourseStructureChapterByIdData = async (id: any) => {
    try {
      await getListMoocCourseStructureChapterById(id)
        .then((res) => {
          const data = res.data.data;
          // console.log(data);
          setListChapter(data);
        })
        .catch((err) => {
          console.log(err);
          message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
        });
    } catch (error) {
      console.log(error);
      message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
    }
  };

  const getListMoocCourseDescriptionDocumentByIData = async (id: any) => {
    {
      try {
        await getListMoocCourseDescriptionDocumentById(id)
          .then((res) => {
            const data = res.data.data;
            // console.log(`res-DescriptionDocument:: `, data);
            setDataDescriptionDocument(data);
          })
          .catch((err) => {
            console.log(err);
            message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
          });
      } catch (error) {
        console.log(error);
        message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
      }
    }
  };

  const [activeTab, setActiveTab] = useState<string>("1");

  useEffect(() => {
    getDetailMoocCourseConstructionPlanData(id);
    getListMoocCourseStructureByIdData(id);
    getListMoocCourseStructureChapterByIdData(id);
    getListMoocCourseDescriptionDocumentByIData(id);
  }, [id, activeTab]);

  const changeToChapterList = (dataCourseStructure: TypeCourseStructure[]) => {
    const level1 = dataCourseStructure
      .filter((item) => item.structureItemLevel === 1)
      .sort((a, b) =>
        a.orderNumber && b.orderNumber ? a.orderNumber - b.orderNumber : 0
      );
    const level2 = dataCourseStructure
      .filter((item) => item.structureItemLevel === 2)
      .sort((a, b) =>
        a.orderNumber && b.orderNumber ? a.orderNumber - b.orderNumber : 0
      );
    const level3 = dataCourseStructure
      .filter((item) => item.structureItemLevel === 3)
      .sort((a, b) =>
        a.orderNumber && b.orderNumber ? a.orderNumber - b.orderNumber : 0
      );

    const chapterList: TypeChapterList[] = level1.map((l1, index) => {
      let chapter: TypeChapterList = {
        id: l1.id,
        courseConstructionPlanId: l1.courseConstructionPlanId,
        structureItemName: l1.structureItemName,
        structureItemDescription: l1.structureItemDescription,
        structureItemLevel: l1.structureItemLevel,
        orderNumber: l1.orderNumber,
        isDeleted: l1.isDeleted,
        subjectList: [],
      };

      // Filter subjects for this chapter
      let chapterSubjects = level2
        .filter((l2) => l2.parentId === l1.id)
        .sort((a, b) =>
          a.orderNumber && b.orderNumber ? a.orderNumber - b.orderNumber : 0
        );

      // Map each subject to include its lessons
      chapter.subjectList = chapterSubjects.map((subject, index) => {
        let subjectItem: TypeSubjectList = {
          id: subject.id,
          courseConstructionPlanId: subject.courseConstructionPlanId,
          structureItemName: subject.structureItemName,
          structureItemDescription: subject.structureItemDescription,
          structureItemLevel: subject.structureItemLevel,
          coursewareType: subject.coursewareType,
          orderNumber: subject.orderNumber,
          parentId: subject.parentId,
          createdDate: subject.createdDate,
          updatedDate: subject.updatedDate,
          isDeleted: subject.isDeleted,
          lessonList: [],
        };

        // Filter lessons for this subject
        let subjectLessons = level3
          .filter((l3) => l3.parentId === subject.id)
          .sort((a, b) =>
            a.orderNumber && b.orderNumber ? a.orderNumber - b.orderNumber : 0
          );

        // Include lessons in the subject
        subjectItem.lessonList = subjectLessons.map((lesson, index) => ({
          id: lesson.id,
          courseConstructionPlanId: lesson.courseConstructionPlanId,
          structureItemName: lesson.structureItemName,
          structureItemDescription: lesson.structureItemDescription,
          structureItemLevel: lesson.structureItemLevel,
          coursewareType: lesson.coursewareType,
          orderNumber: lesson.orderNumber,
          parentId: lesson.parentId,
          createdDate: lesson.createdDate,
          updatedDate: lesson.updatedDate,
          isDeleted: lesson.isDeleted,
        }));

        return subjectItem;
      });

      return chapter;
    });
    // console.log(`chapterList::`, chapterList);
    return chapterList;
  };

  const [listChapter, setListChapter] = useState<TypeCourseStructure[]>([]);

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: t("Thông tin chung", "Thông tin chung"),
      children: isLoading ? (
        <IsLoading />
      ) : (
        <DetailContent isReadOnly={mode === "view" ? true : false}>
          <DetailInfo
            detailData={detailData}
            ltsIndustry={ltsIndustry}
            ltsIndustryGroup={ltsIndustryGroup}
          />
        </DetailContent>
      ),
    },
    {
      key: "2",
      label: t("Cấu trúc khóa học", "Cấu trúc khóa học"),
      children: isLoading ? (
        <IsLoading />
      ) : (
        <>
          {mode !== "view" && (
            <DetailContent>
              <CourseStructure
                dataCourseStructure={dataListCourseStructure}
                setDataCourseStructure={setDataListCourseStructure}
              />
            </DetailContent>
          )}
          {mode === "view" && (
            <DetailContent>
              <PreviewCourseStructure
                dataCourseStructure={dataListCourseStructure}
              />
            </DetailContent>
          )}
        </>
      ),
    },
    {
      key: "3",
      label: t("Tài liệu mô tả", "Tài liệu mô tả"),
      children: isLoading ? (
        <IsLoading />
      ) : (
        <>
          {mode === "view" && (
            <DetailContent>
              <PreviewDescriptionDocument
                listChapter={listChapter}
                dataDescriptionDocument={dataDescriptionDocument}
              />
            </DetailContent>
          )}
          {mode !== "view" && (
            <DetailContent isReadOnly={mode === "view" ? true : false}>
              <DescriptionDocument
                listChapter={listChapter}
                dataDescriptionDocument={dataDescriptionDocument}
                setDataDescriptionDocument={setDataDescriptionDocument}
              />
            </DetailContent>
          )}
        </>
      ),
    },
    {
      key: "4",
      label: t("Kết quả duyệt", "Kết quả duyệt"),
      children: isLoading ? (
        <IsLoading />
      ) : (
        <DetailConfirm />
        // <DetailContent
        //   isReadOnly={mode === "view" ? true : false}
        // >

        // </DetailContent>
      ),
    },
  ];

  // const listBreadcrumb = [
  //   {
  //     title: <a href={`survey-training/list-survey`}>GC Module</a>,
  //   },
  //   {
  //     title: detailData?.organizationName || "",
  //   },
  // ];

  const listBreadcrumb = [
    {
      title: (
        <a
          href={`/${routesConfig.coursePlan}/${routesConfig.registerCoursePlan}/${routesConfig.moocCourseConstructionPlan}`}
        >{t("Kế hoạch khóa học", "Kế hoạch khóa học")}</a>
      ),
    },
    {
      title: (
        <a
          href={`/${routesConfig.coursePlan}/${routesConfig.registerCoursePlan}/${routesConfig.moocCourseConstructionPlan}/${routesConfig.moocCourseConstructionPlanDetail}/${id}`}
        >{t("Xây dựng nội dung khóa học", "Xây dựng nội dung khóa học")}</a>
      ),
    },
    {
      title: detailData?.registrationName || "",
    },
  ];

  const showMessage = (messageContent: string) => {
    if (messageContent.includes(t("thành công", "thành công"))) {
      message.success(messageContent);
    } else {
      message.error(messageContent);
    }
  };

  const { saveDraftCourseStructure, saveDraftDescriptionDocument } =
    useCourseStructure((state) => {
      return {
        saveDraftCourseStructure: state.saveDraftCourseStructure,
        saveDraftDescriptionDocument: state.saveDraftDescriptionDocument,
      };
    });

  // console.log(`dataDescriptionDocument::`, dataDescriptionDocument);

  const handleSaveDraftCourseStructure = async (
    type?: string,
    activeTab?: number
  ) => {
    setIsLoading(true);
    await saveDraftCourseStructure(
      showMessage,
      dataListCourseStructure,
      Number(id),
      type,
      activeTab
    );
    setIsLoading(false); // Kết thúc dù có lỗi xảy ra hay không
  };

  const handleSaveDraftDescriptionDocument = async (
    type?: string,
    activeTab?: number
  ) => {
    setIsLoading(true);

    await saveDraftDescriptionDocument(
      showMessage,
      dataDescriptionDocument,
      Number(id),
      type,
      activeTab
    );

    setIsLoading(false);
  };

  const [isOpenModalApprove, setIsOpenModalApprove] = useState<boolean>(false);
  const [browseData, setBrowseData] =
    useState<DataTypeMoocCourseConstructionPlan>();

  const closeApproveModal = () => {
    setIsOpenModalApprove(false);
    getDetailMoocCourseConstructionPlanData(id);
  };

  return (
    <div className="course-managment-plan-construction">
      <Content>
        <PageHeader
          title={`${t("Kế hoạch khóa học", "Kế hoạch khóa học")} ${detailData.registrationName}`}
          listBreadcrumb={listBreadcrumb}
          arrowLeft={imgPath + "arrowLeft.svg"}
          positionItem="column"
          breadcrumb={true}
        />
        <div className="tabs-heading">
          <Tabs
            activeKey={activeTab} // Set active tab
            onChange={(key) => setActiveTab(key)}
            items={items}
            tabBarExtraContent={
              <Row>
                <Space>
                  <Col>
                    {Number(activeTab) === 2 && (
                      <Button
                        type="default"
                        onClick={() =>
                          handleSaveDraftCourseStructure(
                            "manualSave",
                            Number(activeTab)
                          )
                        }
                        disabled={
                          mode === "view"
                            ? true
                            : detailData.constructionPlanStatus
                            ? detailData.constructionPlanStatus !== 1
                              ? true
                              : false
                            : true
                        }
                      >{t("Bản nháp", "Bản nháp")}</Button>
                    )}
                    {Number(activeTab) === 3 && (
                      <Button
                        type="default"
                        onClick={() =>
                          handleSaveDraftDescriptionDocument(
                            "manualSave",
                            Number(activeTab)
                          )
                        }
                        disabled={
                          mode === "view"
                            ? true
                            : detailData.constructionPlanStatus
                            ? detailData.constructionPlanStatus !== 1
                              ? true
                              : false
                            : true
                        }
                      >{t("Lưu tài liệu", "Lưu tài liệu")}</Button>
                    )}
                  </Col>
                  <Col>
                    <Button
                      type="primary"
                      disabled={
                        mode === "view"
                          ? true
                          : detailData.constructionPlanStatus
                          ? detailData.constructionPlanStatus !== 1
                            ? true
                            : false
                          : true
                      }
                      onClick={() => {
                        setIsOpenModalApprove(true);
                        setBrowseData(detailData);
                      }}
                    >{t("Gửi duyệt", "Gửi duyệt")}</Button>
                    <ApproveCouresConstruction
                      open={isOpenModalApprove}
                      handleCancel={() => {
                        closeApproveModal();
                      }}
                      browseData={browseData}
                    />
                  </Col>
                </Space>
              </Row>
            }
          />
        </div>
      </Content>
    </div>
  );
};

export default DetailCoursePlan;
